import { render } from "./DeviceEd.vue?vue&type=template&id=0f730e72"
import script from "./DeviceEd.vue?vue&type=script&lang=js"
export * from "./DeviceEd.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__